import React from 'react'
import './testimonial.css'
import AVR1 from '../../assets/L1.jpeg'
import AVR2 from '../../assets/jojo.jpeg'
import AVR3 from '../../assets/IMG_8337.jpeg'

// core version + navigation, pagination modules:
import { Pagination, Navigation, Scrollbar } from 'swiper/modules';

import {Swiper, SwiperSlide} from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


const data = [
  {
    avatar: AVR1,
    name: 'Eluan Agbodo',
    review: 'Needless to say, if you have added a review profile with 10k reviews,'  
  },

  {
    avatar: AVR2,
    name: 'Joseph Aninweze',
    review: 'Needless to say, if you have added a review profile with 10k reviews,'  
  },
  {
    avatar: AVR3,
    name: 'obiora',
    review: 'Needless to say, if you have added a review profile with 10k reviews,'  
  },
]

          
const Testimonial = () => {
  return (
    <section id='testimonial'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className='container testimonials__container'
      modules={[Pagination, Navigation, Scrollbar]}
      spaceBetween={40}
      slidesPerView={1}
      // navigation
      pagination={{clickable:true}}
      // scrollbar={{draggable: true}}
      // onSwiper={(swiper) => console.log(swiper)}
      >
        {
          data.map(({avatar,name,review}, index) =>{
            return (
         <SwiperSlide key={index} className='testimonial'>
        <div className='client__avater'>
        <img src={avatar} alt=''/>
        </div>
          <h5 client__name>{name}</h5>
          <small className='client__review'>
           {review}
          </small>
        </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonial